import {Model} from './model';
import {Unserializer} from './serialization';

export class LeadSource implements Model {
  leadSourceId: number;
  name: string;
  created: Date;
  updated: Date;

  static copy(oldObj: LeadSource): LeadSource {
    const newObj = new LeadSource();
    newObj.leadSourceId = oldObj.leadSourceId;
    newObj.name = oldObj.name;
    newObj.created = Unserializer.date(oldObj.created);
    newObj.updated = Unserializer.date(oldObj.updated);
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.leadSourceId;
  }

  isNew(): boolean {
    return isNaN(this.leadSourceId);
  }

  clone(): LeadSource {
    return LeadSource.copy(this);
  }
}
